import { Outlet } from 'react-router-dom';

export function HealthcareEntityDashboard() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
